exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".RawMaterials{color:red}.existentag{position:relative;display:inline-block;height:30px;line-height:30px;padding:0 1em 0 1.75em;background-color:#337ab7;border-radius:50px 3px 3px 50px;color:#fff;font-size:13px;text-decoration:none;-webkit-transition:.2s;transition:.2s}.existentag:after{position:absolute;top:50%;left:10px;z-index:2;display:block;content:\"\";width:6px;height:6px;margin-top:-3px;background-color:#fff;border-radius:100%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/app/pages/raw-materials/raw-materials.scss
// module id = 1416
// module chunks = 0